/*
 * @Description: 【业务工具函数】公式计算：兼容应用新增、应用详情、审批流程详情
 */

import Big from 'big.js'
import { Ref } from 'vue'
import { isEmpty, isNullOrUndefOrEmpty } from '@/utils/is'
import { isSubList, equationTransferValue } from '@/utils/preObjectManage/utils'
import { SignManageFeeFeildEnum, FeeTypeEnum } from '@/enums/preObjectManage'
import { fieldTypeConfig, fieldTypeEnum, moduleType } from '@/enums/preObjectManage'
import { getCalFormulaValue } from '@/views/settingCenter/applyManage/components/formDesignPage/formDesign/components/right/components/other/equation/utils'

/**
 * @description: 公式计算数据处理功能函数
 * @param module 模块数据---响应式数据reactive
 * @param field 字段数据---响应式数据reactive
 * @param formData 表单数据---响应式数据ref
 * @param mapData 数据存储map---普通引用对象
 */
export function formulaCalculation(
  module: Recordable,
  field: Recordable,
  formData: Ref,
  mapData: Recordable
) {
  field.renderConfig?.equationEmitter?.on(
    `equation_${field.fieldSerial}`,
    (changField: Recordable, changeVal: any) => {
      // 处理mapData数据
      const dealMapData = (fieldKey: string) => {
        let val = 0
        changeVal?.value?.forEach((item: Recordable) => (val += Number(item[changField[fieldKey]])))
        mapData[changField.fieldSerial] = Number(val)
        return val
      }

      // 特殊处理金额、百分比字段的mapData数据
      const dealMoneyPercentage = (value: any) => {
        if (changField.code === fieldTypeConfig.money && field.code === fieldTypeConfig.money) {
          mapData[changField.fieldSerial] = equationTransferValue(
            Number(String(value).replace(/,/g, '')),
            changField.unit,
            field.unit
          )
        }
        if (changField.code === fieldTypeConfig.percentage) {
          mapData[changField.fieldSerial] = new Big(Number(value)).div(100)
        }
      }

      // 如果是关联查询字段，还需要处理changeVal
      if (changField?.renderConfig?.valCallback) {
        changeVal = changField.renderConfig.valCallback(changeVal, changField)
      }

      // 子表
      if (isSubList(changField.fieldType)) {
        const data = dealMapData('fieldCode')
        dealMoneyPercentage(data)
      } else if (changField.fieldType === fieldTypeEnum.TABLE_ORIGIN) {
        // 关联表单
        const data = dealMapData('fieldSerial')
        dealMoneyPercentage(data)
      } else {
        mapData[changField.fieldSerial] = isNullOrUndefOrEmpty(changeVal)
          ? changeVal
          : Number(changeVal)
        if (!isNullOrUndefOrEmpty(changeVal)) {
          dealMoneyPercentage(changeVal)
        }
      }

      // 【固定业务逻辑】当计费标准为非"佣金比例"时,"应收服务费"字段值不需使用公式计算
      if (
        field.fieldCode === SignManageFeeFeildEnum.feeMoney &&
        !(Number(formData.value[SignManageFeeFeildEnum.feeType]) === FeeTypeEnum.commissionRate)
      ) {
        return
      }

      const setting = field.setting
        ? !isEmpty(JSON.parse(field.setting))
          ? JSON.parse(field.setting)
          : { web: {} }
        : { web: {} }

      if (setting.web.equation) {
        // 取出配置中的序列号
        const val = getCalFormulaValue(setting.web.equation, mapData)
        if (val !== false) {
          // 子表
          if (module.moduleType === moduleType.subList) {
            changeVal?.value?.forEach((obj: Recordable) => (obj[field.fieldCode] = val))
          } else {
            // 小数位数精度处理
            formData.value[field.fieldCode] = formatNumber(String(val), {
              precisions: field.precisions
            })
          }
        }
      }
    }
  )
}

// 检验数字
function formatNumber(val: string, fieldOption: Record<string, any>) {
  let temp = val.toString()
  temp = temp.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
  temp = temp.replace(/^\./g, '') // 验证第一个字符是数字
  temp = temp.replace(/\.{2,}/g, '') // 只保留第一个., 清除多余的
  // 输入小数位数
  if (fieldOption.precisions) {
    const decimal = temp.split('.')[1]
    const integer = temp.split('.')[0]
    if (decimal) {
      temp = integer + '.' + decimal.substring(0, fieldOption.precisions)
    }
  } else {
    temp = temp.replace(/[^\d]/g, '')
  }
  return temp
}
